import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthRoutes from "./Components/Auth/Routes/AuthRoutes";
import EmployeeLayout from "./Components/Employee/EmployeeLayout/Pages/EmployeeLayout";
import PrivateRoute from "./Components/PrivateRoutes";
import EmployeeRoutes from "./Components/Employee/EmployeeLayout/Routes/EmployeeRoutes";
import JobRoute from "./Components/Employee/Jobs/JobRoutes/JobRoute";
import CandidateRoute from "./Components/Employee/Candidates/CandidateRoutes/CandidateRoute";
import ReportIssue from "./Components/Employee/ReportIssue/Pages/ReportIssue";
import InterviewerRoutes from "./Components/Interviewer/InterviewerRoutes/InterviewerRoutes";
import ConsultantRoutes from "./Components/Consultant/ConsultantLayout/Routes/ConsultantRoutes";
import ConsultantLayout from "./Components/Consultant/ConsultantLayout/Pages/ConsultantLayout";
import AdminRoute from "./Components/Admin/AdminLayout/Routes/AdminRoute";
import AdminLayout from "./Components/Admin/AdminLayout/Pages/AdminLayout";

function App() {
  return (
      <Routes>
        {/* Public Routes */}
        <Route path="/*" element={<AuthRoutes />} />

        <Route path="/Interview/*" element={<InterviewerRoutes />} />

        <Route path="/Consultant/*" element={<ConsultantLayout />}>
          <Route path="*" element={<ConsultantRoutes />} />
        </Route>

        {/* Protected Dashboard */}
        <Route
          path="/Dashboard/*"
          element={
            <PrivateRoute role="employee">
              <EmployeeLayout />
            </PrivateRoute>
          }
        >
          <Route path="Report-Issue" element={<ReportIssue />} />
          {/* Nested routes inside layout */}
          <Route
            path="*"
            element={
              <>
                <EmployeeRoutes />
                <JobRoute />
                <CandidateRoute />
              </>
            }
          />
        </Route>

        <Route path="/Admin" element={<AdminLayout />}>
          <Route path="*" element={<AdminRoute />} />
        </Route>
      </Routes>

  );
}

export default App;
